import { Fill, Stroke, Style } from 'ol/style';
import CircleStyle from 'ol/style/Circle';
const r = function () {
    return Math.round(Math.random() * 255);
};
const g = function () {
    return Math.round(Math.random() * 255);
};
const b = function () {
    return Math.round(Math.random() * 255);
};
function createStyles() {
    return {
        Point: new Style({
            image: new CircleStyle({
                radius: 5,
                fill: new Fill({ color: `rgba(${r()},${g()},${b()},1)` }),
                stroke: new Stroke({ color: 'rgba(100,100,100,1)', width: 1.5 }),
            }),
        }),
        Polygon: new Style({
            stroke: new Stroke({ color: 'rgba(100,100,100,1)', width: 1 }),
            fill: new Fill({ color: `rgba(${r()},${g()},${b()},1)` }),
        }),
        LineString: new Style({
            stroke: new Stroke({ color: `rgba(${r()},${g()},${b()},1)`, width: 2 }),
        }),
        MultiPolygon: new Style({
            stroke: new Stroke({ color: 'rgba(100,100,100,1)', width: 1 }),
            fill: new Fill({ color: `rgba(${r()},${g()},${b()},1)` }),
        }),
    };
}
export function createStyleFunction(layer) {
    const styles = createStyles();
    const selectStyle = function (feature) {
        // @ts-ignore
        const type = feature?.getGeometry().getType();
        // @ts-ignore
        let style = styles[type];
        // @ts-ignore
        if (!layer.style) {
            // @ts-ignore
            layer.style = style;
        }
        else {
            // use cached style
            style = layer.style;
        }
        return style;
    };
    return selectStyle;
}
